import { Injectable } from "@angular/core";
import { EntityCollectionServiceElementsFactory } from "@ngrx/data";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ListingSummary } from "../interfaces/listing-summary";
import { PolarisEntityCollectionServiceBase } from "./polaris-entity-collection-service-base.service";
import { ADBUILDER_LISTING_STATUSES, ListingStatusCodes } from "../interfaces/listing-status";

@Injectable({
	providedIn: "root",
})
export class ListingSummaryService extends PolarisEntityCollectionServiceBase<ListingSummary> {
	constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
		super("ListingSummary", serviceElementsFactory);
	}

	getByKey(mlid: string): Observable<ListingSummary> {
		return this.getWithQuery({
			queryString: `Listing_ID=${mlid}`,
		}).pipe(map((listingSummaries) => listingSummaries[0]));
	}

	queryForAdbuilderCampaigns(summary: ListingSummary, loggedInUser: string): boolean {
		const isListingOrCoListingAgent =
			summary?.listingMemberReference === loggedInUser ||
			summary?.coListingMemberReference === loggedInUser;

		const isResidentialListing = ["SF", "RR"].includes(summary?.propertyTypeCD);
		return isListingOrCoListingAgent && isResidentialListing;
	}

	showAdbuilder(summary: ListingSummary, loggedInUser: string): boolean {
		const isSfWithAdbuilderStatuses =
			summary?.propertyTypeCD === "SF" &&
			ADBUILDER_LISTING_STATUSES.includes(summary?.listingStatusCD);

		const isActiveRental =
			summary?.propertyTypeCD === "RR" && summary?.listingStatusCD === ListingStatusCodes.Active;
		return (
			(summary?.listingMemberReference === loggedInUser ||
				summary?.coListingMemberReference === loggedInUser) &&
			(isSfWithAdbuilderStatuses || isActiveRental)
		);
	}
}
